var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserGainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 19.5588C20.5 23.5398 14.7929 24 10.5013 24L10.1941 23.9997C7.45985 23.9934 0.5 23.8283 0.5 19.5347C0.5 15.6349 5.97772 15.1137 10.2367 15.0941L10.8084 15.0937C13.5425 15.1001 20.5 15.2652 20.5 19.5588ZM10.5013 16.9052C5.12121 16.9052 2.39394 17.7894 2.39394 19.5347C2.39394 21.2957 5.12121 22.1883 10.5013 22.1883C15.8801 22.1883 18.6061 21.3041 18.6061 19.5588C18.6061 17.7978 15.8801 16.9052 10.5013 16.9052ZM10.5013 0C14.1982 0 17.2045 2.87704 17.2045 6.41356C17.2045 9.95008 14.1982 12.8259 10.5013 12.8259H10.4609C6.77146 12.815 3.78283 9.93679 3.79541 6.40994C3.79541 2.87704 6.80303 0 10.5013 0ZM10.5013 1.72478C7.79798 1.72478 5.59846 3.8276 5.59846 6.41356C5.58965 8.99106 7.77273 11.0927 10.4646 11.1023L10.5013 11.9647V11.1023C13.2033 11.1023 15.4015 8.99831 15.4015 6.41356C15.4015 3.8276 13.2033 1.72478 10.5013 1.72478Z",
    fill: "#9142C5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.3281,
    y1: 12.9583,
    x2: 23.3281,
    y2: 6.45825,
    stroke: "#8427B9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26.4648,
    y1: 9.69238,
    x2: 19.9648,
    y2: 9.69238,
    stroke: "#8427B9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGainIcon);
export default __webpack_public_path__ + "static/media/user-gain-icon.9290b95ff853fb2f9ce19bfb6f6df66f.svg";
export { ForwardRef as ReactComponent };